import type { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";
import type { PlanCoverageInfo } from "@/model/demographics";
import type {
  ModifiedCoveragePlanDatesItem,
  ModifiedCoveragePlanDatesPeriod,
} from "@/model/coverage-years";

const initialState = {
  activeCoverage: {} as PlanCoverageInfo,
  coveragePlanDates: [] as ModifiedCoveragePlanDatesItem[],
  selectedCoverageYear: {} as ModifiedCoveragePlanDatesPeriod | null,
};

const activeCoverageSlice = createSlice({
  name: "planCoverageInfo",
  initialState,
  reducers: {
    setActiveCoverage: (state, action: PayloadAction<PlanCoverageInfo>) => {
      // console.log("action.payload", action.payload);
      state.activeCoverage = action.payload;
    },
    setCoveragePlanDates: (
      state,
      action: PayloadAction<ModifiedCoveragePlanDatesItem[]>,
    ) => {
      state.coveragePlanDates = action.payload;
    },
    setSelectedCoverageYear: (
      state,
      action: PayloadAction<ModifiedCoveragePlanDatesPeriod | null>,
    ) => {
      state.selectedCoverageYear = action.payload;
    },
  },
});

export const {
  setActiveCoverage,
  setCoveragePlanDates,
  setSelectedCoverageYear,
} = activeCoverageSlice.actions;
export default activeCoverageSlice.reducer;
